"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandingInputButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
require("./ExpandingInputButton.css");
var classnames_1 = __importDefault(require("classnames"));
var MDIcon_1 = require("../../components/MDIcon");
var InputContainer_1 = require("../../components/InputContainer/InputContainer");
var isType_1 = require("../../utils/isType");
var R = __importStar(require("../../utils/ramda"));
(0, MDIcon_1.preloadIcons)("magnify", "close");
var ExpandingInputButton = function (_a) {
  var _b = _a.onChange,
    _onChange = _b === void 0 ? R.N : _b,
    _c = _a.icon,
    icon = _c === void 0 ? "magnify" : _c,
    _d = _a.width,
    wd = _d === void 0 ? "200px" : _d,
    _e = _a.iconScale,
    iconScale = _e === void 0 ? 1 : _e,
    _f = _a.startingValue,
    startingValue = _f === void 0 ? "" : _f,
    className = _a.className,
    placeholder = _a.placeholder,
    style = _a.style,
    restProps = __rest(_a, ["onChange", "icon", "width", "iconScale", "startingValue", "className", "placeholder", "style"]);
  var _g = __read((0, react_1.useState)(startingValue), 2),
    value = _g[0],
    setValue = _g[1];
  var _h = __read((0, react_1.useState)(startingValue.length > 0), 2),
    expanded = _h[0],
    setExpanded = _h[1];
  var ref = (0, react_1.useRef)(null);
  var dataExpanded = expanded || value.length > 0;
  var cn = (0, classnames_1.default)("vsx-expanding-input-button", className);
  var iconName = (0, isType_1.isString)(icon) ? icon : "blank";
  var iconTransform = iconScale !== 1 ? "translateX(-1px) scale(0.6) scale(".concat(iconScale, ")") : undefined;
  var iconElement = (0, isType_1.isString)(icon) ? null : (0, jsx_runtime_1.jsx)("div", __assign({
    className: "vsx-expanding-input-button-icon-element"
  }, {
    children: icon
  }));
  var width = (0, isType_1.isNumber)(wd) ? "".concat(wd, "px") : wd;
  var onChange = function (newValue) {
    if (newValue !== value) {
      setValue(newValue);
      _onChange(newValue);
    }
  };
  var onClickFocus = function () {
    var _a;
    setExpanded(true);
    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
  };
  return (0, jsx_runtime_1.jsxs)(InputContainer_1.InputContainer, __assign({
    inline: true,
    gap: "none",
    className: cn,
    onClick: onClickFocus,
    "data-expanded": dataExpanded,
    style: __assign(__assign({}, style), {
      width: dataExpanded ? width : "32px"
    }),
    paddingLeft: "none"
  }, restProps, {
    children: [(0, isType_1.isString)(icon) ? (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
      icon: iconName,
      cursor: "pointer",
      style: {
        transform: iconTransform
      },
      className: "vsx-expanding-input-button-icon",
      onClick: onClickFocus
    }) : iconElement, (0, jsx_runtime_1.jsx)("input", {
      ref: ref,
      type: "text",
      value: value,
      onChange: function (e) {
        return onChange(e.currentTarget.value);
      },
      onFocus: function () {
        return setExpanded(true);
      },
      onBlur: function () {
        return setExpanded(false);
      },
      placeholder: placeholder
    }), dataExpanded && (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
      icon: "close",
      cursor: "pointer",
      className: "vsx-expanding-input-button-icon vsx-expanding-input-button-close-icon",
      clickable: true,
      onClick: function (e) {
        var _a;
        onChange("");
        setExpanded(false);
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.blur();
        e.stopPropagation();
      }
    })]
  }));
};
exports.ExpandingInputButton = ExpandingInputButton;